import type { TableSettingsField } from "app/pages/sales-intelligence/common-components/export-table/types";
import InfoIconTooltip from "app/pages/sales-intelligence/common-components/tooltip/InfoIconTooltip/InfoIconTooltip";

import { StyledSimilarWebCell, StyledExample, StyledInfoIconTooltip } from "../styles";

export const SimilarwebCell = ({ entry }: { entry: TableSettingsField }) => {
    const { name, example, tooltipKey } = entry.similarweb;

    return (
        <StyledSimilarWebCell>
            <div>{name}</div>
            <StyledExample>({example})</StyledExample>
            {tooltipKey ? (
                <StyledInfoIconTooltip>
                    <InfoIconTooltip tooltipKey={tooltipKey} />
                </StyledInfoIconTooltip>
            ) : null}
        </StyledSimilarWebCell>
    );
};
